import { createAction, createStandardAction } from 'typesafe-actions';

import { TyreDTO } from '../../types/dto/TyreDTO';
import { TyreLOVDTO } from '../../types/dto/TyreLOVDTO';

export const getTyreSeccaoRequest = createAction('@@app/GET_TYRE_SECCAO_REQUEST');
export const getTyreSeccaoSuccess = createStandardAction('@@app/GET_TYRE_SECCAO_SUCCESS')<TyreLOVDTO[]>();
export const getTyreSeccaoFailure = createAction('@@app/GET_TYRE_SECCAO_FAILURE');

export const getTyreSerieRequest = createAction('@@app/GET_TYRE_SERIE_REQUEST');
export const getTyreSerieSuccess = createStandardAction('@@app/GET_TYRE_SERIE_SUCCESS')<TyreLOVDTO[]>();
export const getTyreSerieFailure = createAction('@@app/GET_TYRE_SERIE_FAILURE');

export const getTyreJanteRequest = createAction('@@app/GET_TYRE_JANTE_REQUEST');
export const getTyreJanteSuccess = createStandardAction('@@app/GET_TYRE_JANTE_SUCCESS')<TyreLOVDTO[]>();
export const getTyreJanteFailure = createAction('@@app/GET_TYRE_JANTE_FAILURE');

export const getTyreListRequest = createAction('@@app/GET_TYRE_LIST_REQUEST');
export const getTyreListSuccess = createStandardAction('@@app/GET_TYRE_LIST_SUCCESS')<TyreDTO[]>();
export const getTyreListFailure = createAction('@@app/GET_TYRE_LIST_FAILURE');

export const tyreContactRequest = createAction('@@app/TYRE_CONTACT_REQUEST');
export const tyreContactSuccess = createAction('@@app/TYRE_CONTACT_SUCCESS');
export const tyreContactFailure = createAction('@@app/TYRE_CONTACT_FAILURE');
